import { useMemo } from 'react';
import { useFormat } from 'helpers/hooks/useFormat';
import CartItem from './cart-item';
import { CartProps } from '../types';

type Props = Pick<CartProps, 'cart' | 'onRemoveItem' | 'onUpdateItem'>;

const CartItemsList = ({ cart, onRemoveItem, onUpdateItem }: Props) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const lineItems = useMemo(() => {
    return (cart?.lineItems ?? []).filter((lineItem) => lineItem.variant?.isOnStock);
  }, [cart?.lineItems]);

  const soldOutItems = useMemo(() => {
    return (cart?.lineItems ?? []).filter((lineItem) => !lineItem.variant?.isOnStock);
  }, [cart?.lineItems]);

  return (
    <div className="mt-3 divide-y divide-neutral-400 border-t border-neutral-400 lg:mt-[34px] lg:border-none">
      {lineItems.map((lineItem) => (
        <div key={lineItem.lineItemId}>
          <CartItem
            item={lineItem}
            classNames={{ moveToWishlist: 'text-[14px]' }}
            onRemoveItem={() => onRemoveItem(lineItem)}
            onUpdateItem={(quantity) => onUpdateItem(lineItem.lineItemId as string, quantity)}
          />
        </div>
      ))}

      {soldOutItems.length > 0 && (
        <div className="border-t border-neutral-400 pt-9">
          <h3 className="text-[16px] md:text-[18px] lg:text-[22px]">
            {formatMessage({ id: 'badges.soldOut', defaultMessage: 'Sold out' })}
          </h3>
          <div className="mt-[52px]">
            {soldOutItems.map((lineItem) => (
              <div key={lineItem.lineItemId}>
                <CartItem
                  item={lineItem}
                  classNames={{ moveToWishlist: 'text-[14px]' }}
                  onRemoveItem={() => onRemoveItem(lineItem)}
                  onUpdateItem={(quantity) => onUpdateItem(lineItem.lineItemId as string, quantity)}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CartItemsList;
